import CollaboratorPicker from "@/components/CollaboratorPicker/collaboratorPicker.component";
import { useUser } from "@/hooks/AppContext/user.hook";
import { Collaborator } from "@/types";
import { User } from "lucide-react";
import React, { useEffect, useState } from "react";

type TaskCellCollaboratorsProps = {
  className: string;
  editing: boolean;
  collaboratorIDs: number[];
  editedCollaboratorsIDs?: number[];
  handleFieldCollaborators?: (id: number) => void;
  collaboratorRef?: React.MutableRefObject<HTMLDivElement | null>;
};

const TaskCellCollaborators: React.FC<TaskCellCollaboratorsProps> = ({
  className,
  editing,
  collaboratorIDs,
  editedCollaboratorsIDs,
  handleFieldCollaborators,
  collaboratorRef,
}) => {
  const { getUserFullNameByID, getUserById, getUserProfileImageByID } =
    useUser();

  const [editedCollaborators, setEditedCollaborators] = useState<
    Collaborator[]
  >([]);

  useEffect(() => {
    // if no editedCollaboratorsIDs use collaboratorIDs
    const newEditedCollaboratorsIDs = editedCollaboratorsIDs || collaboratorIDs;

    const newEditedCollaborators: Collaborator[] = newEditedCollaboratorsIDs
      .map((id) => {
        const user = getUserById(id);
        if (!user) return undefined;
        return {
          id: user.id,
          email: user.email,
          full_name: getUserFullNameByID(user.id),
        };
      })
      .filter((collaborator) => collaborator !== undefined);

    setEditedCollaborators(newEditedCollaborators);
  }, [
    editedCollaboratorsIDs,
    collaboratorIDs,
    getUserById,
    getUserFullNameByID,
  ]);

  return editing &&
    editedCollaborators &&
    handleFieldCollaborators &&
    collaboratorRef ? (
    <div className={className}>
      <CollaboratorPicker
        collaborators={editedCollaborators}
        handleFieldCollaborators={handleFieldCollaborators}
        collaboratorRef={collaboratorRef}
      />
    </div>
  ) : (
    <div className={className}>
      {collaboratorIDs.map((collaboratorID) => (
        <div key={collaboratorID}>
          <div className="flex items-center gap-1">
            {getUserProfileImageByID(collaboratorID) ? (
              <img
                className="size-4 rounded-full shrink-0"
                src={getUserProfileImageByID(collaboratorID)}
              />
            ) : (
              <User className="size-4 rounded-full bg-primary shrink-0" />
            )}

            {getUserFullNameByID(collaboratorID)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TaskCellCollaborators;
